if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-cart-upsell-add]');
        this.errorEl = this.querySelector('.cart-upsell__error');
        this.labelEl = this.querySelector('.cart-upsell__label');
        this.spinner = this.querySelector('.loading__spinner');

        if (this.button) {
          this.button.addEventListener('click', this.onAdd.bind(this));
        }
      }

      onAdd(event) {
        event.preventDefault();
        if (!this.button || this.button.disabled) return;

        const variantId = this.dataset.variantId;
        const cartDrawer = document.querySelector('cart-drawer');
        if (!variantId || !cartDrawer) return;

        this.setError('');
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
        this.spinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id),
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.setError(response.description || window.cartStrings?.error);
              this.button.disabled = false;
              this.button.removeAttribute('aria-disabled');
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-upsell',
              productVariantId: variantId,
              cartData: response,
            }).then(() => {
              cartDrawer.classList.toggle('is-empty', response.item_count === 0);
              cartDrawer.renderContents(response);
            });
          })
          .catch(() => {
            this.setError(window.cartStrings?.error);
            this.button.disabled = false;
            this.button.removeAttribute('aria-disabled');
          })
          .finally(() => {
            this.spinner?.classList.add('hidden');
          });
      }

      setError(message) {
        if (!this.errorEl) return;
        if (!message) {
          this.errorEl.classList.add('hidden');
          this.errorEl.textContent = '';
          return;
        }
        this.errorEl.textContent = message;
        this.errorEl.classList.remove('hidden');
      }
    },
  );
}
